import React, { FC } from 'react';
import { View } from 'react-native';

export const TalkbackOverrideView: FC = () => {
  console.error('Trying to use android only component on web: TalkbackOverrideView.');
  return <View />;
};
